import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '../../../node_modules/@angular/router';
import { OnboardingConfirmationService } from './onboarding-confirmation.service';

@Component({
  selector: 'app-onboarding-confirmation',
  templateUrl: './onboarding-confirmation.component.html',
  styleUrls: ['./onboarding-confirmation.component.scss']
})
export class OnboardingConfirmationComponent implements OnInit {
  imageList = [];

  verificationCode: string = '';
  emailId: string = '';

  constructor(
    private _onBoardingService: OnboardingConfirmationService,
    private _activatedRoute: ActivatedRoute
  ) { }

  ngOnInit() {
    this.imageList = [
      { imageName: 'assets/images/Atlas_Copco_logo.svg' },
      { imageName: 'assets/images/barrick-client-logo.svg' },
      { imageName: 'assets/images/epiroc-logo.png' },
      { imageName: 'assets/images/lhoist-logo.svg' }
    ];

     this.verificationCode = this._activatedRoute.snapshot.queryParams.verificationCode;
     this.emailId = this._activatedRoute.snapshot.queryParams.emailId;

  }

  resendEmail() {

    this._onBoardingService.resendEmail(this.verificationCode)
      .subscribe((data) => {

      }, (err) => {

      });
  }

}



// WEBPACK FOOTER //
// ./src/app/onboarding-confirmation/onboarding-confirmation.component.ts